/*
 * @描述: mixin混合
 * @版本: 1.0
 * @作者: 冯强
 * @创建时间: 2022-11-23 17:39:33
 */
export const pagination = {
  data () {
    return {
      pagination: {
        pageNum: 1,
        pageSizes: [50, 100, 150, 200],
        pageSize: 50,
        total: 0,
        layout: 'total, prev, pager, next, sizes'
      }
    }
  }
}
